import { useMutation } from '@tanstack/react-query';
import { emailApiClient } from 'src/api/FiretrolApiClientInstances';

/** @registry Resolves a signed URL for an email attachment on click. */
export function useDownloadEmailAttachment() {
  return useMutation({
    mutationFn: (attachmentId: number) =>
      emailApiClient.downloadEmailAttachment(attachmentId),
    meta: { errorContext: 'email attachment download' },
  });
}
